/**
 * page.tsx (Inbox) — quem ESCOLHE o arranjo. Rota `/inbox`.
 *
 * Não desenha nada: olha o aparelho e entrega a tela certa. É o padrão da
 * convenção visual §8.3, o mesmo que `autorizacoes/page.tsx` já usa — o
 * endereço não muda porque a pessoa trocou de aparelho (senão o atalho que ela
 * tem no app instalado quebra), e quem decide é um arquivo, não o roteador.
 *
 *   celular              → `page-celular.tsx`    lista que rola, gaveta de pastas
 *   tablet/notebook/PC   → `page-completo.tsx`   coluna de pastas, lote, paginação
 *
 * Como saber que um `page.tsx` é porteiro e não tela: pela PASTA. Se há irmãos
 * com sufixo ao lado, ele escolhe; se não há, ele é a tela.
 *
 * ⚠️ O QUE OS DOIS COMPARTILHAM ESTÁ EM `shared.tsx`, e a divisão é por RISCO:
 * o que dói se divergir (o que cada pasta contém, o contador, o "há 5 dias", a
 * cor da borda) mora lá; o arranjo mora em cada tela. Aqui não há estado a
 * preservar entre os dois — não há formulário —, então trocar de arranjo não
 * perde nada digitado.
 */
import { usarCelular } from '@/lib/tela';
import { InboxCelularPage } from './page-celular';
import InboxCompletoPage from './page-completo';

export default function InboxPage() {
  return usarCelular() ? <InboxCelularPage /> : <InboxCompletoPage />;
}
